import { Typography } from 'antd';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { setterTaskBoardDraggable } from '../../store/slices/taskBoardDraggableSlice';
import { TaskBoardColumnType, TaskBoardDropAreaType } from '../taskBoardTypes';

interface DropAreaProps {
    dropArea: TaskBoardDropAreaType;
    column: TaskBoardColumnType;
}

export const TaskBoardDropArea: React.FC<DropAreaProps> = ({ dropArea, column }) => {
    const dispatch = useDispatch();

    const [isDropAreaActive, setIsDropAreaActive] = useState(false);

    return (
        <div
            onDragEnter={() => {
                setIsDropAreaActive(true);
            }}
            onDragLeave={() => {
                setIsDropAreaActive(false);
            }}
            onDragOver={(e: React.DragEvent<HTMLDivElement>) => {
                e.preventDefault();
            }}
            onDrop={() => {
                setIsDropAreaActive(false);
                dispatch(
                    setterTaskBoardDraggable({
                        drop: {
                            dropAreaId: dropArea.id,
                            dropColumnId: column.id,
                        },
                    }),
                );
            }}
            style={{
                background: isDropAreaActive ? '#cfdff5' : '#e1ebf2',
                padding: 8,
                flex: 1,
                minHeight: 150,
                borderRadius: 16,
                border: '2px solid #a0b8e8',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
            }}
        >
            <div style={{ pointerEvents: 'none' }}>
                <Typography.Text strong>{dropArea.name}</Typography.Text>
            </div>
        </div>
    );
};
